import ComingSoon from '@/components/shared/ComingSoon'
import { FEATURE_FLAG_LABELS, isFeatureEnabled, type FeatureFlagKey } from '@/lib/featureFlags'

interface FeatureFlagProps {
  flag: FeatureFlagKey
  featureName?: string
  children: React.ReactNode
}

export default function FeatureFlag({ flag, featureName, children }: FeatureFlagProps) {
  if (!isFeatureEnabled(flag)) {
    return <ComingSoon featureName={featureName || FEATURE_FLAG_LABELS[flag]} />
  }

  return <>{children}</>
}
